var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor—wrapper"},[_c('div',{ref:"toolbar",staticClass:"toolbar-container"}),_c('div',{ref:"editor",staticClass:"editor-container",on:{"click":_vm.setFoucs}})])
}
var staticRenderFns = []

export { render, staticRenderFns }